// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__3NtOl","inactive":"pagination_inactive__btJck","active_page":"pagination_active_page__VOA9x"};